<div class="filter-btn-main-container">
  <button
    [ngClass]="isHidden"
    (click)="toggleForm()"
    #filterForm
    [class]="
      isFiltered
        ? 'btn btn-light-primary font-weight-bold mr-2 '
        : 'btn  btn-clean font-weight-bold mr-2'
    "
  >
    <span [class]="showForm ? 'flaticon2-down' : 'flaticon2-back'"></span>
    FILTER
    <span *ngIf="isFiltered" class="navi-label">
      <span class="label label-primary label-rounded-circle font-weight-bold">{{
        filterCounter
      }}</span>
    </span>
  </button>
  <div class="filter-form-container" [hidden]="!showForm">
    <form [formGroup]="FilterButtonForm">
      <div class="row" style="margin-bottom: 10px">
        <label class="col-md-4 col-form-label">With Follow-up</label>
        <div class="col-3">
          <span class="switch switch-icon">
            <label>
              <input type="checkbox" formControlName="withFollowUp" />
              <span></span>
            </label>
          </span>
        </div>
        <button class="mr-2" mat-button matTooltip="Clear Form" (click)="resetForm()">Clear</button>
        <button
          class="btn btn-light-primary font-weight-bold mr-2"
          matTooltip="Save Changes"
          (click)="onSubmit()"
        >
          Submit
        </button>
      </div>
      <div style="display: flex; flex-direction: row; justify-content: flex-end">
        <mat-error *ngIf="clickedOutside"> don't forget to click submit </mat-error>
      </div>
      <div style="display: flex; flex-direction: column; margin-bottom: 5px">
        <mat-label>Due Date</mat-label>
        <div class="row" formGroupName="dueDate" style="margin-top: -10.5px">
          <mat-form-field appearance="standard" class="col">
            <mat-label>From Date</mat-label>
            <input
              matInput
              formControlName="fromDateDue"
              [matDatepicker]="fromDueDatePicker"
              placeholder="MM/DD/YYYY"
              ktDateMask
              maxlength="10"
              [max]="maxDueFromDate"
              (dateChange)="setMinDueToDate($event)"
            />
            <mat-datepicker-toggle matSuffix [for]="fromDueDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #fromDueDatePicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="standard" class="col">
            <mat-label>To Date</mat-label>
            <input
              matInput
              formControlName="toDateDue"
              [matDatepicker]="toDueDatePicker"
              [min]="minDueToDate"
              (dateChange)="setMaxDueFromDate($event)"
              placeholder="MM/DD/YYYY"
              ktDateMask
              maxlength="10"
            />
            <mat-datepicker-toggle matSuffix [for]="toDueDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #toDueDatePicker></mat-datepicker>
          </mat-form-field>
          <a
            (click)="clearDueDateFilter()"
            class="col-2 text-primary"
            style="display: flex; align-items: center; cursor: pointer"
            >Clear</a
          >
        </div>
      </div>
      <div style="display: flex; flex-direction: column; margin-bottom: -12.5px">
        <mat-label>Created Date</mat-label>
        <div class="row" formGroupName="createdDate" style="margin-top: -10.5px">
          <mat-form-field appearance="standard" class="col">
            <mat-label>From Date</mat-label>
            <input
              matInput
              formControlName="fromDateCreated"
              [matDatepicker]="fromCreatedDatePicker"
              [max]="maxCreatedFromDate"
              (dateChange)="setMinCreatedToDate($event)"
              ktDateMask
              maxlength="10"
              placeholder="MM/DD/YYYY"
            />
            <mat-datepicker-toggle matSuffix [for]="fromCreatedDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #fromCreatedDatePicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="standard" class="col">
            <mat-label>To Date</mat-label>
            <input
              matInput
              formControlName="toDateCreated"
              [matDatepicker]="toCreatedDatePicker"
              [min]="minCreatedToDate"
              (dateChange)="setMaxCreatedFromDate($event)"
              ktDateMask
              maxlength="10"
              placeholder="MM/DD/YYYY"
            />
            <mat-datepicker-toggle matSuffix [for]="toCreatedDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #toCreatedDatePicker></mat-datepicker>
          </mat-form-field>
          <a
            (click)="clearCreatedDateFilter()"
            class="col-2 text-primary"
            style="display: flex; align-items: center; cursor: pointer"
            >Clear</a
          >
        </div>
      </div>
      <kt-general-autocomplete
        [label]="'User'"
        [loadItemsFunction]="userAutocompleteCall"
        [optionFormatter]="displayUsers"
        [valueFormatter]="displayUsersSelected"
        [required]="false"
        [readOnly]="false"
        [placeholder]="'Search User'"
        [dataPath]="'data'"
        [appearance]="'standard'"
        [change]="handleUserChange.bind(this)"
        [control]="FilterButtonForm.get('user')"
        #userAutocomplete
      ></kt-general-autocomplete>
      <div [hidden]="fromPatient || fromDoctor">
        <kt-general-autocomplete
          [label]="'Entity'"
          [loadItemsFunction]="entityAutocompleteCall"
          [optionFormatter]="stringUtils.autocompleteEntityFormatter"
          [valueFormatter]="stringUtils.displayName"
          [required]="false"
          [readOnly]="false"
          [placeholder]="'Search Entity'"
          [dataPath]="'data'"
          [appearance]="'standard'"
          [change]="handleEntityChange.bind(this)"
          #entityAutocomplete
        ></kt-general-autocomplete>
      </div>
      <div [hidden]="groupedByTeam">
        <mat-form-field appearance="standard" class="mat-form-field-fluid">
          <mat-label>Team</mat-label>
          <mat-select
            multiple
            formControlName="team"
            [compareWith]="compareFn"
            (selectionChange)="onTeamSelectionChange($event)"
          >
            <mat-option
              *ngFor="let category of categoryList"
              [value]="category"
              [disabled]="category?.id !== 0 && disableTeamOptions"
            >
              {{ category.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <kt-general-autocomplete
        [hidden]="groupedByTemplate"
        [label]="'Template'"
        [loadItemsFunction]="this.loadTemplatesList.bind(this)"
        [optionFormatter]="displayTemplate"
        [valueFormatter]="displayTemplateSelected"
        [required]="false"
        [readOnly]="false"
        [placeholder]="'Search Template'"
        [dataPath]="'data'"
        [appearance]="'standard'"
        [change]="handleTemplateChange.bind(this)"
        #templateAutocomplete
      >
      </kt-general-autocomplete>
      <kt-general-autocomplete
        [hidden]="groupedByTag"
        [label]="'Tag'"
        [loadItemsFunction]="this.loadTagsList.bind(this)"
        [optionFormatter]="displayTag"
        [valueFormatter]="displayTagSelected"
        [required]="false"
        [readOnly]="false"
        [placeholder]="'tag'"
        [dataPath]="'data'"
        [appearance]="'standard'"
        [change]="handleTagChange.bind(this)"
        #tagAutocomplete
      >
      </kt-general-autocomplete>
      <mat-form-field appearance="standard" class="mat-form-field-fluid">
        <mat-label>Priority</mat-label>
        <mat-select formControlName="priority">
          <mat-option *ngFor="let priority of priorityOptions" [value]="priority.value">
            {{ priority.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field
        class="mat-form-field-fluid"
        appearance="standard"
        *ngIf="!isCompleted && !isCanceled"
      >
        <mat-label>Status</mat-label>
        <mat-select formControlName="status" placeholder="Status">
          <mat-option value="">{{ 'GLOBAL.ALL' | translate }}</mat-option>
          <mat-option *ngFor="let option of progressOptions" [value]="option">
            <span
              class="mr-10 label label-lg label-light-{{
                getItemCssClassByStatus(option)
              }} label-inline"
              >{{ option | getTaskStatus }}
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <kt-general-autocomplete
        [label]="'Office'"
        [appearance]="'standard'"
        [dataPath]="'data'"
        [loadItemsFunction]="getOfficeAutocomplete"
        [optionFormatter]="displayOffice"
        [valueFormatter]="displayOfficeSelected"
        [required]="false"
        [readOnly]="false"
        [change]="handleOfficeChange.bind(this)"
        [control]="FilterButtonForm.get('office')"
        #officeAutocomplete
      ></kt-general-autocomplete>
    </form>
  </div>
</div>
